import dayjs from 'dayjs';
import { dictWithUrl } from '@/components/lots/api.js';
import store from '@/store/index';
export const getDictWithUrl = async (dictCode) => { // 请求数据字典
    const dictOption = [];
    const dictRes = await dictWithUrl(dictCode);
    if (dictRes) {
        const dictData = dictRes.data[dictCode] || {};
        Object.entries(dictData).forEach(item => {
            dictOption.push(
                {
                    value: item[0],
                    label: item[1]
                }
            );
        });
    }
    return dictOption;
};
export const copyText = (copyText, classFlag) => {
    // if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
    //     return;
    // }
    var input = document.createElement('input');
    input.type = 'text';
    input.value = copyText.trim();
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    this.$message.success(`‘${input.value}’复制成功`);
};

// 通过copyText2.call(vm, text)调用
export const copyText2 = function (copyText) {
    var input = document.createElement('input');
    input.type = 'text';
    input.value =  String(copyText || '').trim();
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    this.$message.success(`‘${input.value}’复制成功`);
};

export const distinctData = (arr, key) => { // 数组去重
    const obj = {};
    arr = arr.filter(i => !!i[key]).reduce(function(item, next) {
        if (!obj[next[key]]) { obj[next[key]] = item.push(next); }
        return item;
    }, []);
    return arr;
};
// 最大查询天数
export const maxDays = (startTime, endTime) => {
    if (new Date(endTime).getTime() - new Date(startTime).getTime() > 63 * 24 * 60 * 60 * 1000) {
        return true;
    }
    return false;
};

/**
 *
 * @description 日期时间控件值转换
 * @method 方法名 setTimeVal
 * @param {object} { 存放时间参数的对象 } obj
 * @param {arrar} { 日期时间控件绑定的值（数组） } dataTimes
 * @param {string} { 开始时间 } startTime
 * @param {string} { 结束时间 } endTime
 * @return {object} obj 返回结果
 */
export const setTimeVal = (obj = {}, dataTimes, startTime, endTime) => {
    obj[dataTimes] = obj[dataTimes] || [];
    if (obj[dataTimes].length) {
        obj[startTime] = dayjs(obj[dataTimes][0]).format('YYYY-MM-DD HH:mm:ss');
        obj[endTime] = dayjs(obj[dataTimes][1]).format('YYYY-MM-DD HH:mm:ss');
    }
    delete obj[dataTimes];
    return obj;
};

/** 权限检查方法 */
export const hasPermission = (value) => {
    let isExist = false;
    const btnPermissionsArr = store.getters.btnPermissions;
    if (btnPermissionsArr === undefined || btnPermissionsArr === null) {
        return false;
    }
    if (btnPermissionsArr.indexOf(value) > -1) {
        isExist = true;
    } else {
        isExist = false;
    }
    return isExist;
};

/**
 * @param {String} str 需要被分割的字符串
 * @param {String} delimiter 分割符号
 * @returns Array<string>
 */
export const strToArray = (str, delimiter = ',') => {
    if (!str || typeof str !== 'string') {
        return [];
    }
    return str.split(delimiter).map(item => item.trim()).filter(Boolean);
};

/** setTimeout的Promise实现
 * @param {Number|String} times 延迟时间，单位ms
 * @returns Promise<void>
 */
export const waitTimes = times => {
    return new Promise(resolve => setTimeout(resolve, times));
};

export const isFalsy = value => {
    return ['', undefined, null].includes(value);
};
/**
    @description解析用户名和用户编码
    将“黄3989(ex_huangjy29)”解析成对象，{userName:'黄3989'，userCode：‘ex_kuang01’}
    将“(财务)匡(exkuang01)”解析成对象，{userName：'(财务)匡'，userCode：‘exkuang01')
*/
export const parseUserStrToobject = str => {
    if (typeof str !== 'string') return { userName: '', userCode: '' };
    const lastOpen = str.lastIndexOf('(');
    const lastClose = str.lastIndexOf(')');
    if (lastOpen === -1 || lastClose === -1 || lastClose < lastOpen) {
        return { userName: '', userCode: '' };
    }
    const userCode = str.slice(lastOpen + 1, lastClose).trim();
    const userName = str.slice(0, lastOpen).trim();
    return { userName, userCode };
};
